<template>
  <div>
   <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">学生个人管理</el-breadcrumb-item>
  <el-breadcrumb-item>学习汇报</el-breadcrumb-item>
  <el-breadcrumb-item>雅思申报</el-breadcrumb-item>
</el-breadcrumb>
<el-card>
<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
<el-row>
  <el-col :span="4">
 <el-form-item label="Listening" prop="listening"><el-input  v-model="ruleForm.listening"  :max="1"  type="number"></el-input></el-form-item>
  </el-col>
   <el-col :span="4">
 <el-form-item label="Reading" prop="reading"><el-input  v-model="ruleForm.reading"  type="number"></el-input></el-form-item>
   </el-col>
     <el-col :span="4">
 <el-form-item label="Writing" prop="writing"><el-input  v-model="ruleForm.writing" type="number"></el-input></el-form-item>
   </el-col>
        <el-col :span="4">
 <el-form-item label="Speaking" prop="speaking"><el-input  v-model="ruleForm.speaking" type="number"></el-input></el-form-item>
   </el-col>
        <el-col :span="4">
 <el-form-item label-width="120px" label="OverBandScore" prop="overBandScore"><el-input  v-model="ruleForm.overBandScore" type="number"></el-input></el-form-item>
   </el-col>
        <el-col :span="4">
 <el-form-item label="CEFRLevel" prop="CEFRLevel"><el-input  v-model="ruleForm.CEFRLevel" ></el-input></el-form-item>
   </el-col>
</el-row>
<el-row>

  <el-col :span="6">
     <el-form-item label="汇报时间" label-width="100px" prop="examTime">
    <el-date-picker
      v-model="ruleForm.examTime"
      type="datetime"
      placeholder="选择日期时间"
      align="right"
       :picker-options="pickerOptions"
      value-format="yyyy-MM-dd HH:mm:ss"
      default-time	
      >
    </el-date-picker>
  </el-form-item>
  </el-col>
   <el-col :span="6">
     <el-form-item label="考试形式" prop="examType">
    <el-radio-group v-model="ruleForm.examType">
      <el-radio label="机考"></el-radio>
      <el-radio label="纸考"></el-radio>
    </el-radio-group>
  </el-form-item>
   </el-col>
</el-row>
<el-row>
  <el-col>
    <el-col :span="20">
 <el-form-item label="UKVINumber" prop="UKVINumber"><el-input  v-model="ruleForm.UKVINumber"  placeholder="如有请一定填上"></el-input></el-form-item>
   </el-col>
  </el-col>
</el-row>
 <el-form-item prop="file">
<el-upload
  
  drag
  ref="upload"
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  :limit="1"
  accept=".pdf"
  :show-file-list="true"
  :on-change="handleChanges"
  :on-remove="handleRemoves"
  >
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
</el-upload>
</el-form-item>
  <el-form-item label="考场地址：" prop="examAddress"><el-input  v-model="ruleForm.examAddress" ></el-input></el-form-item>
  <el-form-item>
    <el-button type="primary" :disabled="subVal" @click="submitForm('ruleForm')">提交</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>

</el-form>

</el-card>
    </div>
  </div>
</template>

<script>
export default {
data(){
  var validatePass = (rule, value, callback) => {
          if (!(value <=100 || Number.isInteger(value))) {
            callback(new Error('成绩不合法'));
          }
          callback();
        
      };
    return{
        pickerOptions: {
          disabledDate(time) {
          return time.getTime() > Date.now();
        }
        },
        rules:{
          listening:[
            {required: true, message: '请输入listening', trigger: 'blur'},
            {validator:validatePass,trigger: 'blur' }
          ],
            reading:[
            {required: true, message: '请输入reading', trigger: 'blur'},
            {validator:validatePass,trigger: 'blur' }
            
          ],
            writing:[
            {required: true, message: '请输入writing', trigger: 'blur'},
            {validator:validatePass,trigger: 'blur' }
          ],
            speaking:[
            {required: true, message: '请输入speaking', trigger: 'blur'},
            {validator:validatePass,trigger: 'blur' }
          ],
            overBandScore:[
            {required: true, message: '请输入overBandScore', trigger: 'blur'},
            {validator:validatePass,trigger: 'blur' }
          ],
            CEFRLevel:[
            {required: true, message: '请输入CEFRLevel', trigger: 'blur'}
          ],
            examAddress:[
            {required: true, message: '请输入考场', trigger: 'blur'}
          ],
            examTime:[
            {required: true, message: '请输入考试时间', trigger: 'blur'}
          ],
          file:[
            {required: true, message: '请选择文件', trigger: 'blur'}
          ],
          examType:[
            {required: true, message: '请选择考试形式', trigger: 'blur'}
          ],
        },
        fileList5:[],
        fileList:[],
        subVal:true,
        ruleForm:{
        listening:'',
        reading:'',
        writing:'',
        speaking:'',
        showList:[],
        overBandScore:'',
        CEFRLevel:'',
        examAddress:'',
        examTime:'',
        examType:'',
        file:'',
        studentID:'',
        UKVINumber:'',
        }
    }
},

created(){
  this.getInfo()
},
methods:{
  getInfo(){
  this.axios.post("/user/getUserByID","userid="+JSON.parse(localStorage.getItem('user')).userid)
 .then(resp=>{
              if(resp.data.status==1){
              this.ruleForm.name=resp.data.result.name
              this.ruleForm.studentID=resp.data.result.studentID
                  if(resp.data.result.studentID==null||resp.data.result.studentID==''){
                 alert("请先完善个人信息，再进行成绩申报")
              }else{
           this.subVal=false
    }
              console.log(resp.data.result)
              }
             })
this.ruleForm.examTime =this.format(new Date(),'yyyy-MM-dd HH:mm:ss')

  },
 submitForm(formName) {
        this.$refs[formName].validate((valid) => {
        if(!valid)
        return
        

let config = { headers: { "Content-Type": "multipart/form-data" } };    
this.axios.post("/ielts/insertIelts",this.ruleForm,config)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.$message.success("添加成功");
            this.$refs.upload.clearFiles()
            this.$refs.ruleForm.resetFields();
          } else {
            this.$message.error(resp.data.message);
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });

        });
      },
      resetForm(formName) {
        this.$refs.upload.clearFiles()
        this.$refs[formName].resetFields();
      },
      format(time, format) {
                var t = new Date(time);
                var tf = function (i) { return (i < 10 ? '0' : '') + i };
                return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
                    switch (a) {
                        case 'yyyy':
                            return tf(t.getFullYear());
                            break;
                        case 'MM':
                            return tf(t.getMonth() + 1);
                            break;
                        case 'mm':
                            return tf(t.getMinutes());
                            break;
                        case 'dd':
                            return tf(t.getDate());
                            break;
                        case 'HH':
                            return tf(t.getHours());
                            break;
                        case 'ss':
                            return tf(t.getSeconds());
                            break;
                    }
                })
            }, 
            handleChanges(file, fileList) {
              const isLt2M = file.size / 1024 / 1024 < 2;
              if(!isLt2M){
            this.$message.error("文件不能超过两兆")
            this.$refs.upload.clearFiles()
              }else{
                this.ruleForm.file=fileList[0].raw
               this.fileList5=fileList
              }
      },handleRemoves(file, fileList) {
        this.ruleForm.file=fileList[0].raw
        this.fileList5=fileList
      },
}
}
</script>

<style>

  
  .el-col {
    border-radius: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/components/work/student/ieltsDeclare.vue